import { CommonLookupItem } from '../../shared/models/common-lookup-item.model';
import { CustomerModel } from '../shared/models/customer-model';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'hr-customer-edit-contracts-and-verified-view',
  templateUrl: './customer-edit-contracts-and-verified-view.component.html',
  styleUrls: ['./customer-edit-contracts-and-verified-view.component.less'],
  standalone: false,
})
export class CustomerEditContractsAndVerifiedViewComponent implements OnInit {
  @Input('customer')
  public customer: CustomerModel;

  @Input('contractTypes')
  public contractTypes: CommonLookupItem<number, string>[];

  @Output()
  public onUpdate: EventEmitter<CustomerModel> =
    new EventEmitter<CustomerModel>();

  constructor() {}

  onUpdateVerified(event: any) {
    this.onUpdate.emit(this.customer);
  }

  onUpdateContract(event: any) {
    this.onUpdate.emit(this.customer);
  }

  ngOnInit() {}
}
